export type Direction = 'FORWARD' | 'BACKWARD'

// Minimum horizontal pixels a touch must cover to be recognized as a swipe.
export const X_THRESHOLD = 50
